import { Form as AntdForm, Space } from "antd";
import FormProvider, { useFormContext } from "./FormProvider";

const Form = ({
  render,
  direction = "vertical",
  size = "middle",
  style,
  children,
  ...props
}) => {
  return (
    <FormProvider {...props}>
      <FormComponent
        render={render}
        direction={direction}
        size={size}
        style={style}
      >
        {children}
      </FormComponent>
    </FormProvider>
  );
};

const FormComponent = ({ style, direction, size, render, children }) => {
  const { onFinish, formConfig, methods } = useFormContext();
  return (
    <AntdForm
      onFinish={onFinish}
      {...formConfig}
      style={{ width: "100%", ...style }}
    >
      <Space direction={direction} size={size} style={{ width: "100%" }}>
        {render ? render(methods) : children}
      </Space>
    </AntdForm>
  );
};

export default Form;
